<script>
import { mapActions } from 'vuex'

export default {
  name: 'Dashboard',
  computed: {
    enrollmentsSolutionsTotal () {
      return this.dashEnrollmentsSolutions.chartDataTotal > 0 ? this.dashEnrollmentsSolutions.chartDataTotal : 0
    },

    enrollmentsTracksTotal () {
      return this.dashEnrollmentsTracks.chartDataTotal > 0 ? this.dashEnrollmentsTracks.chartDataTotal : 0
    },

    enrollmentsTypeEad () {
      if (!this.dashEnrollmentsSolutionsType.length ||
        !this.dashEnrollmentsSolutionsType[0].hasOwnProperty('barChartDataTotal')
      ) {
        return 0
      }

      return this.dashEnrollmentsSolutionsType[0].barChartDataTotal
    },

    enrollmentsTypeWhatsApp () {
      if (!this.dashEnrollmentsSolutionsType.length ||
        !this.dashEnrollmentsSolutionsType[1].hasOwnProperty('barChartDataTotal')
      ) {
        return 0
      }

      return this.dashEnrollmentsSolutionsType[1].barChartDataTotal
    },

    canRead () {
      return this.getContextPermission('dashboard') === 'read'
    }
  },

  methods: {
    ...mapActions([
      'setFetching',
      'setFeedback',
      'attemptGetTotalEnrollments',
      'attemptGetTotalEnrollmentsSolutionsByStatus',
      'attemptGetTotalEnrollmentsTracksByStatus',
      'attemptGetTotalRegistersLastWeeks',
      'attemptGetTotalEnrollmentsByDay'
    ])
  },

  components: {
    ChartBar: () => import('@/components/general/ChartBar'),
    ChartLine: () => import('@/components/general/ChartLine'),
    ChartPie: () => import('@/components/general/ChartPie'),
    SelectField: () => import('@/components/general/SelectField'),
    FormSection: () => import('@/components/general/FormSection'),
    DashboardCard: () => import('@/components/macro/DashboardCard')
  },

  data () {
    return {
      fileb64: {
        download: true,
        filename: 'Relatório_Soluções.xlsx',
        mimetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        encoding: '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'
      },

      OptionsPie: {
        legend: {
          display: true
        },

        percentageLabel: true,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },

              ticks: {
                display: false,
                beginAtZero: true
              },

              stacked: true
            }
          ],

          yAxes: [
            {
              gridLines: {
                display: false
              },

              ticks: {
                display: false,
                beginAtZero: true
              }
            }
          ]
        }
      },

      Options: {
        legend: {
          display: true
        },

        scales: {
          xAxes: [
            {
              gridLines: {
                display: true
              },

              ticks: {
                display: true,
                beginAtZero: true
              }
            }
          ],

          yAxes: [
            {
              gridLines: {
                display: true
              },

              ticks: {
                display: true,
                beginAtZero: true
              }
            }
          ]
        }
      },

      dashEnrollmentsSolutions: {
        chartData: null,
        chartDataTotal: null
      },

      dashEnrollmentsSolutionsType: [],
      dashEnrollmentsTracks: {
        chartData: null,
        chartDataTotal: null
      },

      dashEnrollmentsByDay: {
        lineChartData: null,
        lineChartDataTotal: null
      },

      dashEnrollmentsBySolution: {
        barChartData: null,
        barChartDataTotal: null
      },

      dashUsers: {
        barChartData: null,
        barChartDataTotal: null
      }
    }
  },

  created () {
    if (!this.canRead) {
      this.setFeedback({ message: this.$t('global.error.permission') })

      return
    }

    this.attemptGetTotalEnrollments().then((response) => {
      this.dashEnrollmentsSolutionsType.push({
        barChartData: {
          datasets: response[0].datasets,
          labels: response[0].labels
        },
        barChartDataTotal: response[0].totalItens
      })

      this.dashEnrollmentsSolutionsType.push({
        barChartData: {
          datasets: response[1].datasets,
          labels: response[1].labels
        },
        barChartDataTotal: response[1].totalItens
      })
    })

    this.attemptGetTotalEnrollmentsSolutionsByStatus().then((response) => {
      this.dashEnrollmentsSolutions.chartData = {
        datasets: response.datasets,
        labels: response.labels
      }

      this.dashEnrollmentsSolutions.chartDataTotal = response.totalItems
    })

    this.attemptGetTotalEnrollmentsTracksByStatus().then((response) => {
      this.dashEnrollmentsTracks.chartData = {
        datasets: response.datasets,
        labels: response.labels
      }

      this.dashEnrollmentsTracks.chartDataTotal = response.totalItems
    })

    this.attemptGetTotalEnrollmentsByDay().then((response) => {
      this.dashEnrollmentsByDay.lineChartData = {
        datasets: response.datasets,
        labels: response.labels
      }

      this.dashEnrollmentsByDay.lineChartDataTotal = response.totalItems
    })

    this.attemptGetTotalRegistersLastWeeks().then((response) => {
      this.dashUsers.barChartData = {
        datasets: [
          {
            label: response.datasets[0].label,
            backgroundColor: response.datasets[0].backgroundColor,
            data: response.datasets[0].data
          },
          {
            label: response.datasets[1].label,
            backgroundColor: response.datasets[1].backgroundColor,
            data: response.datasets[1].data
          }
        ],
        labels: response.labels
      }

      this.dashUsers.barChartDataTotal = response.totalItems
    })
  }
}
</script>

<template>
  <section
    v-if="canRead"
    class="dashboard"
  >
    <div class="dashboard-graphics center">
      <iframe
        width="1078"
        height="2000"
        src="https://lookerstudio.google.com/embed/reporting/475acc32-c4e0-46e7-b24f-0e0aa3ca1cba/page/6ea1B"
        frameborder="0"
        style="border:0"
        allowfullscreen
        allow-downloads
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads allow-forms"
      />
    </div>
  </section>
</template>

<style>
  .dashboard .center {
    max-width: 1078px;
    width: 1078px;
  }

  .dashboard-graphics {
    margin: 80px auto;
  }
</style>
